import { gql } from '@apollo/client'

export const CREATE_REACTIONS = gql`
  mutation createReactions($input: [CreateReactionsInput]) {
    bulkCreateReactions(input: $input) {
      ack
    }
  }
`
